<template>

	<div class="field checkbox">

		<input type="checkbox" 
		:id="fieldname" 
		:name="fieldname" 
		v-model="checked" 
		:true-value="1"
		:false-value="0"
		@focus="isFocused = true"
		@blur="isFocused = false"
		tabindex="0"
		role="checkbox"
		aria-labelledby="checkbox-label"
		>

		<div class="checkmark" :class="{focus: isFocused}">
			<div class="sign vcheck">
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
				<path id="Tick-V" d="M5.3,7.9c0.7,0,3.9,6,4.4,6.6C10.3,14,17.7,1.1,18.5,1c0.7,0,4.2,1.7,4.2,2.4
				C22.7,4,10.7,23,9.9,23c-0.8,0-8.4-12.4-8.6-13C1.5,9.3,4.7,7.9,5.3,7.9z" />
			</svg>
		</div>
		<div class="sign cross">
			<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
			<path d="M23.3,2.3c0-0.7-3.6-1.7-4.5-1.7c-1,0.1-6.5,7.3-7.3,7.8c-0.6-0.6-4.7-6.2-5.6-6.2C5.2,2.1,1.8,3,1.6,3.7C1.7,4,5.3,8.4,8.4,11.9C3.5,17.2,1,20.3,1,20.7c0,0.7,3.6,1.7,4.5,1.7c1-0.1,5.6-6.6,6.4-7.1c0.6,0.6,5.6,6.8,6.5,6.8c0.8,0,4.1-0.9,4.4-1.6c-0.2-0.3-4.6-5.3-7.7-8.7C19.9,6.4,23.3,2.7,23.3,2.3z" />
		</svg>
	</div>
</div>

<label :for="fieldname" :class="{'hasSuccess': checked}" class="inlineblock"><slot name="msg"></slot><span v-if="isRequired" class="req" tabindex="-1">*</span></label>

    <!-- ACCESSIBILITY : added tabindex-->
<div class="errorMessage" v-if="isInError" tabindex="0">{{errorMessage}}</div>
<div class="helper" role="textbox" :aria-label="'More info for ' + fieldname + ' field'">{{helper}}</div>

</div>

</template>

<!-- ================================================================================== -->

<script>
	import FormFields from "../mixins/FormFields";
	export default {
		name:"customCheckbox",

		mixins: [FormFields],
		
		data() {
			return {
				isFocused: false,
			}
		},
		computed: {
			checked: {
				get() {
					return this.modelValue;
				},
				set(newVal) {
					this.$emit('update:modelValue', newVal);
					this.$emit('runCheck', {fieldname: this.fieldname, valid: Boolean(newVal)});
				}
			}
		},
		
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped></style>
